import React from "react"
import { Chip, makeStyles } from "@material-ui/core"
import Config from "react-global-configuration"
import { preventDefault } from "../../utils"

const useStyles = makeStyles((theme) => ({
  root: {
    fontWeight: 500,
    color: theme.palette.text.light,
    backgroundColor: theme.palette.chips.background,
  },
}))

const useFeaturedStyles = makeStyles((theme) => ({
  root: {
    fontWeight: 500,
    color: theme.palette.text.tinted,
    backgroundColor: theme.palette.featured.main,
  },
}))

const TemplateCategoryChip = ({ category: { id, name }, onClick }) => {
  const classes = useStyles()
  const featuredClasses = useFeaturedStyles()
  const { featuredCategory: featuredId } = Config.get("templates")

  const handleCategoryClick = (categoryId) => {
    if (onClick) onClick(categoryId)
  }

  return (
    <Chip
      clickable
      label={name}
      size="small"
      classes={id === featuredId ? featuredClasses : classes}
      onClick={(event) => preventDefault(event, handleCategoryClick(id))}
    />
  )
}

export { TemplateCategoryChip }
